<template>
  <div class="knifed-page-container">
    <!-- 文本内容区域 -->
    <div v-if="this.$i18n.locale === 'zh'" class="knife-text-section">
      <p class="title">断刀？<br>
        放心裁，大胆产。</p>
      <p class="subtitle"></p>
      <p class="desc">太势S系列可选配断刀检测功能，<br>断刀即停，你的面料，我寸步不让。</p>
    </div>

    <div v-else class="knife-text-section">
      <div class="knife-en-left">
        <span style="color: #46b1e1">The blade breaks？</span>
        <span>Cut Fearlessly.</span>
        <span>Produce Confidently.</span>
      </div>
      <div class="knife-en-right">
        <span>Optional Broken Blade Detection</span>
        <span style="color: #808080">Instant Stop on Fracture (<0.2s response)</span>
        <span style="color: #808080">Absolute Material Protection</span>
        <span style="margin-top: 15px">Your fabric’s integrity?</span>
        <span>We defend it down to the millimeter.</span>
      </div>
    </div>


    <!-- 图片展示区域 -->
    <div class="knife-image-section">
      <img
          src="../../static/contact/blade4.png"
          alt="设备检测图"
          class="device-img"
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'KnifeDetectionPage',
  data() {
    return {
      // 可在这里添加后续可能用到的数据
    }
  },
  mounted() {
    this.$nextTick(() => {
      const masterTimeline = this.$gsap.timeline({
        scrollTrigger: {
          trigger: ['.knife-text-section', '.knife-image-section'],
          start: 'top 100%',
          end: 'bottom 0%',
          markers: false,
          // scrub: 1,
          toggleActions: 'play none none none',
          once: true
        }
      })
      masterTimeline.from('.knife-text-section', {
        opacity: 0,
        y: 200,
        duration: 1,
        scale: 0.8,
        ease: 'power2.out',
        transformOrigin: "0%",
      })

      masterTimeline.from('.knife-image-section', {
        opacity: 0,
        y: 200,
        duration: 1,
        transformOrigin: "0%",
      })

      // masterTimeline.to('.knife-image-section', {
      //   opacity: 0,
      //   y: -200,
      //   duration: 1,
      // },5)
    })
  }
}
</script>

<style scoped>
.knifed-page-container {
  width: 100%;
  min-height: 100vh;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center; /* 新增：垂直居中整个容器内容 */
  box-sizing: border-box;
  padding: 100px 0; /* 将margin-top改为padding，避免页面顶部空白 */
  margin-top: 500px;
}

.knife-text-section {
  /* 关键修改：文本内容和容器都居中 */
  text-align: center;
  margin-bottom: 40px;
  max-width: 800px;
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  position: relative;
}

.title {
  font-size: 3em;
  color: #46b1e1;
  font-weight: 700;
  letter-spacing: -0.5px;
  line-height: 1.2;
  text-align: left; /* 确保标题居中 */
}

.subtitle {
  font-size: 2.5em;
  color: #333;
  margin-bottom: 25px;
  font-weight: 500;
  line-height: 1.3;
}

.desc {
  text-align: left; /* 确保描述文本居中 */
  font-size: 1.2em;
  color: #666;
  line-height: 1.8;
  letter-spacing: 0.3px;
}

.knife-image-section {
  width: 100%;
  display: flex;
  justify-content: center;
}

.device-img {
  max-width: 100%;
  height: auto;
  border: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.knife-en-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: var(--font-size-lg2);
}

.knife-en-right {
  position: absolute;
  top: -30px;
  display: flex;
  flex-direction: column;
  left: 65%;
  font-size: var(--font-size-lg);
  width: 80%;
  text-align: left;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .title {
    font-size: 36px;
  }

  .subtitle {
    font-size: 26px;
  }

  .desc {
    font-size: 18px;
  }
}

@media (max-width: 480px) {
  .title {
    font-size: 28px;
  }

  .subtitle {
    font-size: 22px;
  }

  .desc {
    font-size: 16px;
  }
}
</style>

